<main id="main" class="error-50x">
    <header class="ba-content-header ba-with-overlay ba-with-image">
        <div class="ba-header-image">
            <div class="flash"></div>
        </div>
        <div class="ba-content-wrap">
            <div class="ba-overlay">
                <h1>{{ "error.default.title" | i18next }}</h1>
            </div>
        </div>
    </header>
    <div class="container-fluid ba-copytext">
        <p>
            {{ "error.default.text1" | i18next }}
        </p>
        <p>
            {{ "error.default.text2" | i18next }}
        </p>
    </div>
</main>